var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChecklight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5905 3.87177L5.09052 10.3718C5.0334 10.4288 4.95595 10.4609 4.87521 10.4609C4.79447 10.4609 4.71703 10.4288 4.6599 10.3718L1.81615 7.52803C1.76233 7.47027 1.73303 7.39387 1.73442 7.31494C1.73582 7.236 1.76779 7.16069 1.82362 7.10487C1.87944 7.04904 1.95475 7.01707 2.03369 7.01567C2.11262 7.01428 2.18902 7.04358 2.24677 7.0974L4.87521 9.72533L11.1599 3.44115C11.2177 3.38733 11.2941 3.35803 11.373 3.35942C11.4519 3.36082 11.5272 3.39279 11.5831 3.44862C11.6389 3.50444 11.6709 3.57975 11.6723 3.65869C11.6736 3.73762 11.6443 3.81402 11.5905 3.87177Z",
    fill: "#62708C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecklight);
export default __webpack_public_path__ + "static/media/checklight.813a928deb050a5d9328f41c0d54dd1e.svg";
export { ForwardRef as ReactComponent };